import { configureStore } from '@reduxjs/toolkit';
import tokenSetReducer from '@/slices/features/tokenSet/tokenSetSlice';
import filtersReducer from '@/slices/features/filtersSlice';
import errorReducer from '@/slices/features/errorSlice';
import shortlistsReducer from '@/slices/features/shortlistsSlice';
import accountReducer from '@/slices/features/accountSlice';
import modalReducer from '@/slices/features/modalSlice';
import searchResultsFiltersReducer from '@/slices/features/searchProfilesFiltersSlice';

const makeStore = () => {
  return configureStore({
    reducer: {
      tokenSet: tokenSetReducer,
      filters: filtersReducer,
      searchResultsFilters: searchResultsFiltersReducer,
      shortlists: shortlistsReducer,
      account: accountReducer,
      error: errorReducer,
      modal: modalReducer,
    },
  });
};

let store: ReturnType<typeof makeStore>;

export const getStore = () => {
  if (!store) {
    store = makeStore();
  }
  return store;
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
